var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMetricData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 130,
    viewBox: "0 0 136 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8287,
    cy: 24.2999,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.935,
    cy: 36.0528,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.23,
    cy: 42.088,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.641,
    cy: 62.0997,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.2516,
    cy: 63.4503,
    rx: 45.4235,
    ry: 45.0265,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.675 63.4503C110.675 87.7572 90.7944 107.477 66.2517 107.477C41.7089 107.477 21.8281 87.7572 21.8281 63.4503C21.8281 39.1434 41.7089 19.4238 66.2517 19.4238C90.7944 19.4238 110.675 39.1434 110.675 63.4503Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.89901,
    cy: 43.0411,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2052,
    cy: 117.689,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.1705,
    cy: 124.994,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.2887,
    cy: 116.418,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 81.8176,
    cy: 114.512,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 84.9933,
    cy: 123.724,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 72.6056,
    cy: 127.535,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 115.488,
    cy: 107.683,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 125.652,
    cy: 88.7824,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 119.459,
    cy: 78.9347,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 122,
    cy: 58.923,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 127.24,
    cy: 48.1232,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 123.588,
    cy: 23.8234,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 48.6232,
    cy: 129.123,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 25.9113,
    cy: 125.947,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 29.0881,
    cy: 120.388,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 8.44158,
    cy: 94.9767,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 13.0461,
    cy: 85.1291,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1.29363,
    cy: 59.5588,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 13.841,
    cy: 39.7062,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 16.3815,
    cy: 11.5939,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 40.6818,
    cy: 0.794118,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 71.6525,
    cy: 13.1828,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.964,
    cy: 9.21209,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.946 96.7238C112.244 96.7238 111.675 96.1549 111.675 95.4532C111.675 94.7515 112.244 94.1826 112.946 94.1826",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83496 74.965C4.53669 74.965 5.10555 74.3961 5.10555 73.6944C5.10555 72.9927 4.53669 72.4238 3.83496 72.4238",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0996 11.5939C49.8013 11.5939 50.3702 11.025 50.3702 10.3233C50.3702 9.6216 49.8013 9.05273 49.0996 9.05273",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9116 7.1473C79.2099 7.1473 78.641 7.71616 78.641 8.41789C78.641 9.11961 79.2099 9.68848 79.9116 9.68848",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37549 107.761H10.3461M17.0167 100.376V101.408M24.799 107.761H25.8314M17.0167 114.114V115.305M17.0167 116.894V121.102M14.0784 107.761C16.0637 107.761 17.0961 104.902 17.0961 104.902C17.0961 104.902 17.4137 107.761 19.9549 107.761C18.8114 107.761 17.1755 108.794 17.0167 110.858C17.0167 110.858 16.8317 109.168 16.2225 108.555C15.7139 108.044 14.0784 107.761 14.0784 107.761Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.426 16.6758L114.455 16.6758M107.705 27.1582L107.785 23.0288M100.002 16.6758L98.9699 16.6758M107.705 10.4817L107.705 2.38173M110.723 16.6758C108.738 16.6758 107.705 19.5347 107.705 19.5347C107.705 19.5347 107.388 16.6758 104.846 16.6758C105.99 16.6758 107.626 15.6435 107.785 13.5788C107.785 13.5788 107.97 15.2692 108.579 15.8817C109.087 16.3932 110.723 16.6758 110.723 16.6758Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9995 114.918H42.9995C40.2381 114.918 37.9995 112.679 37.9995 109.918V41.918C37.9995 39.1565 40.2381 36.918 42.9995 36.918H77.9212C79.293 36.918 80.6045 37.4815 81.5486 38.4767L96.6268 54.37C97.5082 55.299 97.9995 56.5307 97.9995 57.8113V109.918C97.9995 112.679 95.7609 114.918 92.9995 114.918Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9995 35.918V49.418C79.9995 52.7317 82.6858 55.418 85.9995 55.418H98.9995",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.4995,
    y: 67,
    width: 8,
    height: 37,
    rx: 3,
    stroke: "#194590",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4995,
    y: 77,
    width: 8,
    height: 27,
    rx: 3,
    stroke: "#194590",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4995,
    y: 46,
    width: 8,
    height: 8,
    rx: 4,
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4995,
    y: 84,
    width: 8,
    height: 20,
    rx: 3,
    stroke: "#194590",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMetricData);
export default __webpack_public_path__ + "static/media/no-metric-data.2817ae46482f45bf315aa19ba7892be5.svg";
export { ForwardRef as ReactComponent };